import { IBand } from 'apps/marketplace/store/contractLanes/types'

export const laneAlertsTypeComment = (duration: string) =>
  `Lane Alert carriers are notified about a load ${duration} before it's available online and posted on DAT.`
export const offerTypeComment = (duration: string) =>
  `Reserved Offer carriers have loads reserved exclusively for them; they have ${duration} to accept or decline.`

export const mapOption = (prefixId = '') => ({
  dataTest,
  label,
  value,
}: {
  label: string
  value: string
  dataTest?: string
}) => {
  const id = [prefixId, value].filter(Boolean).join('-')
  return {
    label,
    value,
    id,
    dataTest: dataTest || id,
  }
}

export const ANY = 'any'
export const SAME = 'same-everyday'
export const DIFFERENT = 'different-everyday'
export const SAME_DAY = 'same-day'
export const NEXT_DAY = 'next-day'
export const ANY_PICKUP_TIME = 'Any'
export const DELIVERY_TIME_LABELS = {
  [ANY]: 'Any',
  [SAME_DAY]: 'Same day',
  [NEXT_DAY]: 'Next day',
}

export const OFFER_TYPE = 'auto_offer'
export const LANE_ALERTS_TYPE = 'lane_alert'
export const RADIUS_RATE = 'radius'
export const LANE_RATE = 'lane'
export const CUSTOM_START_DATE = 'custom-start'

export const RATE_ACTION_TYPES = [
  {
    label: 'Reserved Offer',
    value: OFFER_TYPE,
  },
  {
    label: 'Lane Alerts',
    value: LANE_ALERTS_TYPE,
  },
].map(mapOption('action-type'))

export const RATE_TYPES = [
  {
    label: 'Lane (City to City)',
    value: LANE_RATE,
  },
  {
    label: 'Radius (City to Anywhere within a radius)',
    value: RADIUS_RATE,
  },
].map(mapOption('rate-type'))

export const updateRadiusRate = (
  radiusRates: IBand[],
  id: string,
  change: { checked?: boolean; value?: string }
) => {
  const [max, min] = id
    .split('-')
    .reverse()
    .map((edge: string) => parseFloat(edge))
  const rate = radiusRates.find(
    ({ max: rangeTo, min: rangeFrom }) => min === rangeFrom && max === rangeTo
  )
  Object.assign(rate, change)
  return radiusRates
}
export const SPOT_LOAD_TYPE = 'spot'
export const CONTRACT_LOAD_TYPE = 'contract'
export const ANY_LOAD_TYPE = 'any'

export const LOAD_TYPE_OPTIONS = [
  {
    label: 'Any',
    value: ANY_LOAD_TYPE,
  },
  {
    label: 'Contract Only',
    value: CONTRACT_LOAD_TYPE,
  },
  {
    label: 'Spot Only',
    value: SPOT_LOAD_TYPE,
  },
].map(mapOption('load-type'))

export const ASAP = 'asap'
export const START_TIME_OPTIONS = [
  {
    label: 'ASAP',
    value: ASAP,
  },
  {
    label: 'On...',
    value: CUSTOM_START_DATE,
  },
].map(mapOption('start-time'))

export const EXPIRES_30_DAYS = 'expires-30-days'
export const CUSTOM_END_DATE = 'custom-end'
export const EXPIRATION_DATE_OPTIONS = [
  {
    label: 'In 30 Days',
    value: EXPIRES_30_DAYS,
  },
  {
    label: 'On...',
    value: CUSTOM_END_DATE,
  },
].map(mapOption('expiration-time'))

export const PICKUP_TIME = [
  { value: ANY, label: 'Any time' },
  { value: SAME, label: 'Same hours each day' },
  { value: DIFFERENT, label: 'Different hours each day' },
]

export const DELIVERY_TIME_OPTIONS = [
  {
    value: ANY,
    label: 'Any time',
  },
  {
    value: SAME_DAY,
    label: 'Same-day',
  },
  {
    value: NEXT_DAY,
    label: 'Next-day',
  },
].map(mapOption('delivery-time'))

export const CARRIER_ACTIVE_MESSAGE =
  'This carrier will start receiving shipments when the next waterfall starts. (Shipments will be offered every hour from 8am to 5pm.)'
export const CARRIER_INACTIVE_MESSAGE =
  'Submit an approval request on their Carrier Profile to notify Compliance and invite the carrier to complete their onboarding.'
